import {config} from "@/config";
import React, {useEffect} from "react";

export default function SvgColors(props) {
  const {colors} = props;
  const {websiteId} = config;

  return (
    <svg style={{height: "0", width: "0"}}>
      {colors?.map((c, index) => {
        if (c === "red") {
          return (
            <defs key={`${c}-${index}`}>
              <radialGradient id="redGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="30%" stopColor="var(--bs-red-400)" stopOpacity={1} />
                <stop offset="100%" stopColor="var(--bg-app)" stopOpacity={0} />
              </radialGradient>
              <linearGradient id="redGradient" x1="0%" y1="30%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="var(--bs-red-400)" />
                <stop offset="100%" stopColor="var(--bs-red-900)" />
              </linearGradient>
            </defs>
          );
        } else if (c === "yellow") {
          return (
            <defs key={index}>
              <radialGradient id="yellowGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="30%" stopColor="#FFC133" stopOpacity={1} />
                <stop offset="100%" stopColor="var(--bg-app)" stopOpacity={0} />
              </radialGradient>
              <linearGradient id="yellowGradient" x1="0%" y1="30%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#FFE30A" />
                <stop offset="100%" stopColor="#FFC133" />
              </linearGradient>
            </defs>
          );
        } else if (c === "green") {
          return (
            <defs key={index}>
              <radialGradient id="greenGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="40%" stopColor="var(--bs-green-500)" stopOpacity={1} />
                <stop offset="100%" stopColor="var(--bg-app)" stopOpacity={0} />
              </radialGradient>
              <linearGradient id="greenGradient" x1="0%" y1="30%" x2="10%" y2="100%">
                <stop offset="0%" stopColor="var(--bs-green)" />
                <stop offset="100%" stopColor="var(--bs-green-500)" />
              </linearGradient>
              <linearGradient id="green" x1="0%" y1="30%" x2="10%" y2="100%">
                <stop offset="0%" stopColor="var(--bs-green-500)" />
                <stop offset="100%" stopColor="var(--bs-green-500)" />
              </linearGradient>
            </defs>
          );
        } else if (c === "blue") {
          return (
            <defs key={index}>
              <radialGradient id="blueDarkGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="30%" stopColor="#868CD8" stopOpacity={1} />
                <stop offset="100%" stopColor="var(--bg-app)" stopOpacity={0} />
              </radialGradient>
              <radialGradient id="blueLightGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="30%" stopColor="#90E3F9" stopOpacity={1} />
                <stop offset="100%" stopColor="var(--bg-app)" stopOpacity={0} />
              </radialGradient>
              <linearGradient id="blueDarkGradient" x1="0%" y1="30%" x2="10%" y2="100%">
                <stop offset="0%" stopColor="#3962EA" />
                <stop offset="100%" stopColor="#3962EA" />
              </linearGradient>
              <linearGradient id="blueLightGradient" x1="0%" y1="30%" x2="10%" y2="100%">
                <stop offset="0%" stopColor="#7ACEFC" />
                <stop offset="100%" stopColor="#7ACEFC" />
              </linearGradient>
            </defs>
          );
        } else if (c === "purple") {
          return (
            <defs key={index}>
              <radialGradient id="purpleLightGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="30%" stopColor="#EBBBFC" stopOpacity={1} />
                <stop offset="100%" stopColor="var(--bg-app)" stopOpacity={0} />
              </radialGradient>
              <radialGradient id="purpleDarkGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="30%" stopColor="#756ECD" stopOpacity={1} />
                <stop offset="100%" stopColor="var(--bg-app)" stopOpacity={0} />
              </radialGradient>
              <linearGradient id="purple" x1="0%" y1="30%" x2="10%" y2="100%">
                <stop offset="0%" stopColor={websiteId == 1 ? "#756ECD" : "#D39AFF"} />
                <stop offset="100%" stopColor={websiteId == 1 ? "#756ECD" : "#D39AFF"} />
              </linearGradient>
            </defs>
          );
        } else if (c === "black") {
          return (
            <defs key={index}>
              <linearGradient id="black" x1="0%" y1="30%" x2="10%" y2="100%">
                <stop offset="0%" stopColor="#000000" />
                <stop offset="100%" stopColor="#000000" />
              </linearGradient>
            </defs>
          );
        } else return null;
      })}
    </svg>
  );
}
